<template>
    <div class="submenu-tabs">
        <div class="title">{{ title }}</div>
        <div :class="['tabs', { isSub: haveSubtitle }]">
            <div
                :class="['tab-item', { active: !item.children && item.name === active }]"
                v-for="item in tabs"
                :key="item.id"
                @click="clickTabItem(item)"
            >
                <template v-if="item.children">
                    <a-divider orientation="left">{{ item.name }}</a-divider>

                    <div
                        :class="['subtitle', { active: active === sub.name }]"
                        v-for="sub in item.children"
                        :key="sub.name"
                        @click.stop="clickTabItem(sub)"
                    >
                        {{ sub.name }}
                    </div>
                </template>

                <template v-else>
                    <a-icon type="caret-right" v-show="item.name === active" />
                    <span>{{ item.name }}</span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: this.propActive ?? ''
        };
    },
    props: {
        haveSubtitle: {
            type: Boolean,
            default: false
        },
        title: String,
        tabs: {
            type: Array,
            default: () => []
        },
        propActive: String
    },

    watch: {
        propActive: {
            handler(val) {
                this.active = val;
            },
            deep: true
        }
    },

    mounted() {
        if (this.tabs.length) {
            if (this.haveSubtitle && this.tabs[0]?.children.length) {
                this.active = this.tabs[0]?.children[0]?.name;
                this.$emit('changeTab', this.tabs[0].children[0]);
                return;
            }

            this.active = this.tabs[0]?.name;
            this.$emit('changeTab', this.tabs[0]);
        }
    },

    methods: {
        clickTabItem(item) {
            this.active = item.name;
            this.$emit('changeTab', item);
        }
    }
};
</script>

<style lang="scss" scoped>
.submenu-tabs {
    font-family: PingFangSC-Semibold;
    width: 292px;
    border-radius: 4px;
    background-color: #fff;

    .title {
        background: url(../assets/home/left-title-bg.png) no-repeat center;
        height: 76px;
        padding: 21px 31px;
        font-size: 24px;
        color: #ffffff;
        font-weight: 600;
    }

    .tabs {
        padding: 24px 8px;
        .tab-item {
            position: relative;
            font-size: 16px;
            color: #333333;
            // height: 48px;
            padding: 13px 32px 13px 42px;
            color: #333;
            cursor: pointer;

            > .anticon-caret-right {
                position: absolute;
                left: 24px;
                top: 50%;
                transform: translateY(-50%);
            }

            &.active {
                opacity: 0.9;
                background: #005299;
                font-weight: 600;
                color: #fff;
            }
        }

        &.isSub {
            padding: 0;
            padding-bottom: 24px;

            .tab-item {
                padding: 0;
            }

            :deep(.ant-divider) {
                margin: 12px 0;
                .ant-divider-inner-text {
                    color: #333333;
                    font-size: 16px;
                    line-height: 20px;
                }
            }

            .subtitle {
                margin: 0 8px 4px;
                padding-left: 32px;
                font-size: 16px;
                color: #333333;
                height: 40px;
                line-height: 40px;
                cursor: pointer;

                &.active {
                    color: #fff;
                    background: #005299;
                    border-radius: 2px;
                    font-weight: 600;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>
